import React, { Component } from 'react';
import { PriceCards } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

/**
 * The price cards section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
class PriceCardsView extends Component {

	render () {
		const { heading, priceOptions } = this.props.content.landingPage.priceCards;

		return (
			<PriceCards {...{ heading, priceOptions }} />
		);
	}

}

export default withLanguageContext(PriceCardsView);



// WEBPACK FOOTER //
// ./src/components/views/PriceCardsView/PriceCardsView.js